import type { DataRow } from "@kontextwerk/web-sdk/ui/layout/Table.svelte"
import type {
  ContactOrderPlanningPreview,
  ContactOrderPostalSelection,
} from "../../../../../api/kehrblatt/contact-orders"

export const CONTACT_ORDER_DIGITAL_CHANNELS = ["EMAIL", "MOBILE_MESSAGE", "PHONE"] as const

export type ContactOrderDigitalChannel = (typeof CONTACT_ORDER_DIGITAL_CHANNELS)[number]

export type ContactOrderTagDefinition = {
  label: string
  subLabel?: string | null
  color: string
  icon?: string | null
  tooltip?: string | null
  tooltipHtml?: boolean
  nameLabel?: string | null
  roleLabel?: string | null
}

export type ContactOrderChannelValue = {
  channel: ContactOrderDigitalChannel
  customerId: string
  customerLabel: string
  value: string
  contactPointId?: string | null
  isVerified?: boolean
}

export type ContactOrderDigitalPlan = Record<string, ContactOrderDigitalChannel[]>

export type RowCommunicationSelection = {
  digitalByCustomerId: ContactOrderDigitalPlan
  postal: ContactOrderPostalSelection
}

export type ContactOrderRecipientTag = {
  customerId: string
  nameLabel: string
  roleLabel?: string | null
  tag: ContactOrderTagDefinition
  channelValues: ContactOrderChannelValue[]
}

export type ContactOrderChannelToggle = {
  key: string
  channel: ContactOrderDigitalChannel
  customerId: string
  recipientLabel?: string | null
  label: string
  topLabel: string
  subLabel?: string | null
  active: boolean
  color: string
  icon?: string | null
  tooltip: string
  tooltipHtml?: boolean
  disabledReason?: string | null
}

export type ContactOrderPostalToggleOption = {
  value: string
  mode: ContactOrderPostalSelection["mode"]
  customerId?: string | null
  label: string
  selectedLabel?: string
  disabled?: boolean
  tooltip?: string | null
  selection?: ContactOrderPostalSelection
  address?: import("../../../../../api/kehrblatt/contact-orders").AppointmentPostalAddress | null
}

export type ContactOrderAppointmentRow = DataRow & {
  event: ScheduleEvent
  termin: string
  timeLabel: string
  addressLines: string[]
  employee: string
  orderTag: {
    label: string
    numberLabel: string
    subLabel?: string | null
    color: string
    tooltip?: string | null
    tooltipHtml?: boolean
  }
  appointmentTag: ContactOrderTagDefinition
  propertyTag: {
    label: string
    subLabel?: string | null
    color: string
    icon: string
    tooltip?: string | null
  }
  recipients: ContactOrderRecipientTag[]
  unitScope: "BUILDING" | "RESIDENTIAL"
  unitScopeLabel: string
  planningPreview?: ContactOrderPlanningPreview | null
  planningPreviewError?: string | null
  customerInformationMode?: string | null
  customerInformationLabel?: string | null
  customerInformationDetail?: string | null
  isDirty: boolean
  removed?: boolean
}

export type ContactOrderLoadingRow = DataRow & {
  id: string
  isLoading: true
}

export type ContactOrderTableRow = ContactOrderAppointmentRow | ContactOrderLoadingRow
